import { render, staticRenderFns } from "./quicktable.vue?vue&type=template&id=b28f2fc2&"
import script from "./quicktable.vue?vue&type=script&lang=js&"
export * from "./quicktable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports